import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { BaseInputComponent } from '../base-input/base-input.component';
import { CheckBoxInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class CheckboxComponent extends BaseInputComponent implements OnInit {
    @Input() input: CheckBoxInputType;
    constructor(private questionStateService: QuestionStateService) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
    }

    onClick() {
        this.checkForErrors();
        if (this.input.infoCallBack) {
            this.input.infoCallBack.function.call(this.input.infoCallBack.this, this.input);
        }
    }

    onCheckBoxClick($event: MatCheckboxChange) {
        if (this.input.clickCallBack) {
            this.input.clickCallBack.function.call(this.input.infoCallBack.this, this.input);
        }
    }
}
